<template>
  <div>
    <v-file-input
      label="Images"
      accept="image/*"
      display-size
      small-chips
      counter
      multiple
      prepend-icon="fa-camera"
      v-model="files"
    ></v-file-input>
    <v-btn block :disabled="files==''" color="primary" @click="loadFiles">Load</v-btn>
    <v-progress-linear v-model="loadingStatus" v-show="loadingFiles" class="my-1" color="green"></v-progress-linear>
    <v-container grid-list-sm fluid>
      <v-layout wrap>
        <v-flex v-for="(image, n) in images" :key="n" xs6>
          <v-card flat tile>
            <v-img :src="image.url" height="150px"></v-img>
            <v-text-field label="Caption" v-model="image.caption" @change="changeCaption"></v-text-field>
            <v-btn icon top right small color="red" @click="deleteDialog=true;imgToDelete=n">
              <v-icon small>fa-trash</v-icon>
            </v-btn>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog v-model="deleteDialog" width="500">
      <v-card>
        <v-card-title class="headline" primary-title>Delete image</v-card-title>
        <v-card-text>Do you want really to delete the image definitively?</v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="deleteDialog=false;imgToDelete=-1">Cancel</v-btn>
          <v-btn :loading="loading" color="error" text @click="deleteImage">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Firebase from "@/firebase";
export default {
  props: {
    article: Object,
    blockIndex: Number
  },
  data() {
    return {
      files: [],
      loading: false,
      deleteDialog: false,
      articleStorage: Firebase.storage()
        .ref()
        .child(this.article.id),
      images: [],
      imgToDelete: -1,
      loadingFiles: false,
      loadingStatus: 0
    };
  },
  mounted() {
      console.log(this.blockIndex);
      
    if (this.blockIndex !== undefined) {
      this.images = this.article.blocks[this.blockIndex].content!=undefined?this.article.blocks[this.blockIndex].content:[];
    } else {
      this.images = this.article.picture.images!=undefined?this.article.picture.images:[];
    }
  },
  methods: {
    deleteImage: function() {
      this.loading = true;
      Firebase.storage()
        .ref()
        .child(this.images[this.imgToDelete].path)
        .delete()
        .then(res => {
          this.images.splice(this.imgToDelete, 1);
          this.$emit("change", this.images);
        })
        .catch(e => console.log(e))
        .finally(() => {
          this.deleteDialog = false;
          this.loading = false;
        });
    },
    changeCaption: function() {
      this.$emit("change", this.images);
    },
    loadFiles: function() {
      this.loadingFiles = true;
      this.files.forEach(file => {
        var task = this.articleStorage.child(file.name).put(file);
        task.on(
          "state_changed",
          snapshot => {
            var percentage =
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            console.log(percentage);
            this.loadingStatus = percentage;
          },
          err => {
            this.loadingFiles = false;
          },
          () => {
            task.snapshot.ref
              .getDownloadURL()
              .then(url => {
                this.images.push({
                  url,
                  path: task.snapshot.ref.fullPath,
                  caption: ""
                });
                this.$emit("change", this.images);
              })
              .catch(err => console.log(err));
            this.files = [];
            this.loadingFiles = false;
          }
        );
      });
    }
  }
};
</script>
